import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createContext, useContext, useState } from 'react';
var OrderStateLoginContext = /*#__PURE__*/createContext(null);
var OrderSetterLoginContext = /*#__PURE__*/createContext(null);
export function EcommerceLoginProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var defaultLogin = props.defaultLogin || null;

  var _useState = useState(defaultLogin),
      login = _useState[0],
      setLogin = _useState[1];

  return /*#__PURE__*/_jsx(OrderStateLoginContext.Provider, {
    value: login,
    children: /*#__PURE__*/_jsx(OrderSetterLoginContext.Provider, {
      value: setLogin,
      children: children
    })
  });
}
export function useLogin() {
  var login = useContext(OrderStateLoginContext);
  var setLogin = useContext(OrderSetterLoginContext);
  return [login, setLogin];
}